export default __webpack_public_path__ + "static/media/1729.b230db6d.png";